import { computed, Directive, inject } from '@angular/core';

import { MessagesConstants } from '@shared/constants/messages.constants';
import { EventType, WorkflowStep } from '@shared/services/gql.service';
import { injectPermissions } from '@shared/store/auth/auth.service';
import { EventQuery } from '@shared/store/event/event.query';
import { WorkflowQuery } from '@shared/store/workflow/workflow.query';

@Directive({ standalone: true })
export class InvoiceWorkflowDirective {
  private readonly eventQuery = inject(EventQuery);
  private readonly workflowQuery = inject(WorkflowQuery);

  permissions = injectPermissions({
    hasEditInvoice: 'PERMISSION_UPDATE_INVOICES',
  });

  readonly isInvoiceLocked = this.workflowQuery.getLockStatusByWorkflowStepType(
    WorkflowStep.WF_STEP_MONTH_CLOSE_LOCK_INVOICES
  );

  private iCloseMonthsProcessing = this.eventQuery.selectProcessingEvent(
    EventType.CLOSE_TRIAL_MONTH
  );

  disabledAddInvoiceUI = computed(
    () =>
      this.isInvoiceLocked() ||
      !!this.iCloseMonthsProcessing() ||
      !this.permissions().hasEditInvoice
  );
  disabledSyncInvoicesUI = computed(
    () => this.isInvoiceLocked() || !!this.iCloseMonthsProcessing()
  );
  invoiceAddActionTooltip = computed(() => {
    if (!this.permissions().hasEditInvoice) {
      return MessagesConstants.DO_NOT_HAVE_PERMISSIONS_TO_ACTION;
    }

    if (this.invoiceLockTooltip()) {
      return this.invoiceLockTooltip();
    }

    return '';
  });
  invoiceLockTooltip = computed(() => {
    if (this.isInvoiceLocked()) {
      return MessagesConstants.INVOICES_LOCKED;
    }

    return '';
  });
}
